module.exports = __webpack_public_path__ + "img/sld_scb_1_t1_dark.8e3f30fe.svg";